/* eslint-disable max-len */
import React from 'react';
import { number, shape, string, bool, oneOf, node } from 'prop-types';
import { commitmentUnionTypes, getDurationUnit } from '@paddl/utils-js';
import { LogoCardWithText } from '../../../..';
import { DetailsWrapper } from '../../../Activity.styles';
import { getCommitment, getAttendanceCourse } from '../../../../Utils/activities';
export const CourseRead = _ref => {
  let {
    data: {
      details: {
        trainer,
        course,
        courseDuration,
        commitment,
        attendanceOnline,
        attendanceInPerson
      }
    },
    editButton
  } = _ref;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, course.name), /*#__PURE__*/React.createElement(LogoCardWithText, {
    title: trainer.name
  }), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(courseDuration.value, " ").concat(getDurationUnit(courseDuration.unit, courseDuration.value), " \u2022 ").concat(getCommitment(commitment), " \u2022 ").concat(getAttendanceCourse(attendanceOnline, attendanceInPerson))));
};
CourseRead.propTypes = {
  data: shape({
    details: shape({
      trainer: shape({
        id: number,
        name: string
      }).isRequired,
      course: shape({
        id: number,
        name: string
      }).isRequired,
      courseDuration: shape({
        value: number,
        unit: string
      }).isRequired,
      commitment: oneOf(commitmentUnionTypes),
      attendanceOnline: bool,
      attendanceInPerson: bool
    }).isRequired
  }).isRequired,
  editButton: node
};
CourseRead.defaultProps = {
  editButton: undefined
};